import { render } from "./DataProtectionPolicy.vue?vue&type=template&id=4ca682c5"
import script from "./DataProtectionPolicy.vue?vue&type=script&lang=js"
export * from "./DataProtectionPolicy.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__